import { Component, Input, inject } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
    NgbAccordionBody,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionDirective,
    NgbAccordionHeader,
    NgbAccordionItem
} from '@ng-bootstrap/ng-bootstrap';
import { Menu, MenuItem } from './menu.interface';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FlaggedMenuItemEvent } from '../../common/interfaces/flagged-menu-item-event';
import { FlaggedMenuItemService } from '../../common/services/flagged-menu-item.service';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'lib-menu',
    standalone: true,
    imports: [
        FaIconComponent,
        NgbAccordionBody,
        NgbAccordionButton,
        NgbAccordionCollapse,
        NgbAccordionDirective,
        NgbAccordionHeader,
        NgbAccordionItem,
        NgForOf,
        NgIf,
        RouterLink,
        NgClass,
        RouterLinkActive
    ],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})
export class MenuComponent {
    private readonly flaggedMenuItemService = inject(FlaggedMenuItemService);


    @Input() menus: Menu[] = [];

    flaggedMenuItemsMap: Map<string, boolean> = new Map<string, boolean>();
    faCircleExclamation = faCircleExclamation;

    constructor() {
        this.flaggedMenuItemService.flaggedEvent$
            .pipe(takeUntilDestroyed())
            .subscribe(flaggedEvent => {
                this.updateFlaggedMenuItemEvents(flaggedEvent);
            });
    }

    isFlagged(displayText: string): boolean {
        return this.flaggedMenuItemsMap.get(displayText) ?? false;
    }

    hasChildren(menu: Menu) {
        return Array.isArray(menu.children) && menu.children.length > 0;
    }

    onMenuClick(event: Event, clickedMenu: Menu) {
        event.preventDefault();

        this.menus.forEach(menu => {
            menu.open = (menu === clickedMenu) ? !menu.open : false;
        });

        if (clickedMenu.action instanceof Function) {
            clickedMenu.action(event, clickedMenu);
        }
    }

    onMenuItemClick(event: Event, menuItem: MenuItem) {
        if (menuItem.action instanceof Function) {
            menuItem.action(event, menuItem);
        }
    }

    private updateFlaggedMenuItemEvents(flaggedEvent: FlaggedMenuItemEvent): void {
        if (flaggedEvent.value) {
            this.flaggedMenuItemsMap.set(flaggedEvent.key, true);
        } else {
            this.flaggedMenuItemsMap.delete(flaggedEvent.key);
        }
    }
}
